import React, { useEffect, useState } from "react";
import {
  startOfWeek,
  addMinutes,
  format,
  isValid,
  isSameDay,
  isBefore,
  parseISO,
} from "date-fns";
import CalendarEvent from "./calendar-event";
import CalendarEventMins from "./calendar-event-mins";
import EventPopup from "./event-popup";
import { convertUTCToLocal } from "../../common/constant/constant";

const WorkWeek = ({
  currentDate,
  allEvents,
  cancelMeeting,
  calOpen,
  setCalOpen,
  setMeetId,
  closePopup,
  selectedEvent,
  setSelectedEvent,
  setTrialInfo,
  handleCall,
}) => {
  const [currentTime, setCurrentTime] = useState(new Date());
  const [popupPosition, setPopupPosition] = useState(null);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTime(new Date());
    }, 60000);
    return () => clearInterval(interval);
  }, []);

  const validDate = isValid(currentDate) ? currentDate : new Date();
  const startOfCurrentWeek = startOfWeek(validDate, { weekStartsOn: 1 });

  return (
    <div className="bg-white shadow-md rounded-lg overflow-hidden relative">
      <div className="calendar-weekdays-header grid grid-cols-[80px_repeat(5,minmax(0,1fr))] border-b bg-gray-100 pr-[var(--scrollbar-width)]">
        <div className="border-r border-gray-300"></div>
        {[...Array(5)].map((_, i) => {
          const day = addMinutes(startOfCurrentWeek, i * 1440);
          const isToday = isSameDay(day, new Date());
          return (
            <div
              key={i}
              className={`text-left p-2 ${
                isToday ? "blue_color active" : "title_color"
              }`}
            >
              {isValid(day) ? (
                <>
                  <span className="date-big-fonts">{format(day, "dd")}</span>
                  <br />
                  <span className="date-small-fonts">
                    {format(day, "EEEE")}
                  </span>
                </>
              ) : (
                "Invalid Date"
              )}
            </div>
          );
        })}
      </div>

      <div className="h-[calc(100vh-240px)] overflow-y-auto">
        {[...Array(48)].map((_, i) => {
          const hour = Math.floor(i / 2);
          const minute = (i % 2) * 30;
          return (
            <div
              key={i}
              className="grid grid-cols-[80px_repeat(5,minmax(0,1fr))] border-b h-[34px] relative"
            >
              <div className="border-r border-gray-300 text-gray-500 text-sm flex items-center justify-center bg-white pt-[25px]">
                <span className="z-10">
                  {" "}
                  {minute
                    ? ""
                    : `${minute ? "" : hour}:${minute === 0 ? "00" : ""}`}
                </span>
              </div>
              {[...Array(5)].map((_, j) => {
                const day = addMinutes(
                  startOfCurrentWeek,
                  j * 1440 + hour * 60 + minute
                );
                const isToday = isSameDay(day, new Date());
                const currentHour = currentTime.getHours();
                const currentMinutes = currentTime.getMinutes();
                const todayMidnight = new Date();
                const isCurrentTimeSlot =
                  hour === currentHour &&
                  minute <= currentMinutes &&
                  currentMinutes < minute + 30;
                const isPastDay = isBefore(day, todayMidnight);
                const topPosition = currentMinutes < 60 ? "0%" : "50%";
                const isCurrentHour = i === currentHour;
                return (
                  <div key={j} className="border-r relative h-full">
                    {/* {isToday && isCurrentTimeSlot && (
                      <div className="absolute w-full border-t-2 border-red-500" style={{ top: `${(currentMinutes % 30) / 30 * 100}%` }}></div>
                    )} */}
                    {isToday && isCurrentTimeSlot && (
                      <div
                        className="absolute w-full"
                        style={{
                          top: `${(currentMinutes / 60) * 100}%`,
                          borderTop: "2px solid red",
                        }}
                      ></div>
                    )}

                    {isPastDay && isCurrentTimeSlot && (
                      <div
                        className="absolute w-full"
                        style={{
                          top: `${(currentMinutes / 60) * 100}%`,
                          borderTop: "2px dotted red",
                        }}
                      ></div>
                    )}
                    {isToday && isCurrentTimeSlot && (
                      <div
                        className={`absolute w-full h-full border-black`}
                        style={{
                          top: topPosition,
                        }}
                      ></div>
                    )}

                    <div className="flex">
                      {allEvents
                        .filter((event) => {
                          const eventStart = convertUTCToLocal(event.startTime);
                          return (
                            isSameDay(eventStart.localDate, day) &&
                            eventStart.hours === hour &&
                            eventStart.minutes >= minute &&
                            eventStart.minutes < minute + 30
                          );
                        })
                        .map((event, index, filteredEvents) => {
                          const eventStart = convertUTCToLocal(event.startTime);
                          const width = `${100 / filteredEvents.length}%`;
                          return (
                            <CalendarEventMins
                              key={index}
                              event={event}
                              onClick={(selected, position) => {
                                setSelectedEvent(selected);
                                setPopupPosition(position);
                              }}
                              style={{ width, position: "relative" }}
                            />
                          );
                        })}
                    </div>
                  </div>
                );
              })}
            </div>
          );
        })}
      </div>
      {selectedEvent && (
        <EventPopup
          setTrialInfo={setTrialInfo}
          event={selectedEvent}
          position={popupPosition}
          closePopup={closePopup}
          cancelMeeting={cancelMeeting}
          onClose={() => setSelectedEvent(null)}
          calOpen={calOpen}
          setCalOpen={setCalOpen}
          setMeetId={setMeetId}
          handleCall={handleCall}
        />
      )}
    </div>
  );
};

export default WorkWeek;
